import React from "react";
import { Form } from "antd";
import { useOrderMarkStore } from "@/store/hooks";
import { getAntdMarkIcon } from "@/services/api/setting/orderMark";
import { observer } from "mobx-react-lite";
import EcSelect from "@/components/EcSelect";

const OrderMarkField: React.FC = () => {
    const { listSkipDeleted, loadList, loading } = useOrderMarkStore();

    const listSkipDeletedData = listSkipDeleted.map((orderMark) => {
        const { id, remark, icon, color } = orderMark;

        const IconComponent = getAntdMarkIcon(icon);

        return {
            value: id,
            label: (
                <span className="ml5">
                    {IconComponent ? <IconComponent style={{ color }} className="mr5" /> : null}
                    {remark}
                </span>
            ),
        };
    });

    const data = [{ value: 0, label: "无标记" }, ...listSkipDeletedData];

    return (
        <Form.Item label={<span className="search-field-label">订单标记</span>} name="markIds">
            <EcSelect onOpenChange={loadList} data={data} loading={loading} separator={null} multiple />
        </Form.Item>
    );
};

export default React.memo(observer(OrderMarkField));
